import { UNEXPECTED_ERROR } from "components/constants/errorCodes";

const SmartIdErrorMessagesService = {
  getErrorMessage: (errorCode) => {
    switch (errorCode) {
      case 'missing_required_fields':
        return 'missing_required_fields';
      case 'smart_id_session_expired':
        return 'smart_id_start_session_page_session_expired';
      case 'smart_id_user_refused':
        return 'smart_id_start_session_page_user_refused';
      case 'smart_id_user_account_issue':
        return 'smart_id_start_session_page_user_account_issue';
      case 'smart_id_not_verified':
        return 'smart_id_verification_missing';
      case 'smart_id_polling_error':
        return UNEXPECTED_ERROR;
      case 'personal_code_duplicate':
        return 'personal_code_duplicate';
      case 'blockedLogin':
        return 'blocked_login_after_unsuccessful_attempts';
      case 'client_personal_code_not_found':
        return 'smartid_client_personal_code_not_found';
      case 'smart_id_user_account_not_found_by_personal_code':
        return 'smart_id_user_account_not_found';
      case 'rate_limit_reached':
        return 'smart_id_rate_limit_reached';
      default:
        return UNEXPECTED_ERROR;
    }
  }
};

export default SmartIdErrorMessagesService;